import { render, staticRenderFns } from "./ServiceOrderCreate.vue?vue&type=template&id=142944c3&scoped=true&"
import script from "./ServiceOrderCreate.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142944c3",
  null
  
)

export default component.exports